import React from 'react';
import { Box, Skeleton, styled } from '@mui/material';

const SkeletonPadded = styled(Skeleton)(({ theme }) => ({
    'margin': '20px',
}));

export const Loading = props => {
    return (
        <Box sx={props.sx}>
            <SkeletonPadded variant="rectangular" width="80%" height={50} />
            <SkeletonPadded variant="rectangular" width="80%" height={118} />
            <SkeletonPadded animation="wave" />
            <SkeletonPadded animation="wave" />
            <SkeletonPadded variant="rectangular" width="60%" height={118} />
            <SkeletonPadded animation="wave" />
            <SkeletonPadded variant="text" />
            <SkeletonPadded animation="wave" />
        </Box>
    );
};

export default Loading;
